
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schedule/event2",
      function () {
        return require("private-next-pages/schedule/event2/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schedule/event2"])
      });
    }
  